export default __webpack_public_path__ + "static/media/Background_00176.3025334e.png";